//矢印削除
import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { ArrowDb, updateArrow, deleteArrow } from '../redux/arrowDbSlice';

import useOneArrowDb from '../hooks/useOneArrowDb';
import useArrowDbsByCard from '../hooks/useArrowDbsByCard';

type DeleteArrowDialogProps = {
  open: boolean;
  onClose: () => void;
  id?: string;
}
const DeleteArrowDialog: React.FC<DeleteArrowDialogProps> = ({open, onClose, id}) => {
  const dispatch = useDispatch();
  const arrow = useOneArrowDb(id);
  const [nominatedIds, nominatedValues] = useArrowDbsByCard(arrow?.fromId);

  const updateOrder = () => {
    if (nominatedIds.length === 0 || !arrow) return;
    const ids: string[] = [];
    const values: ArrowDb[] = [];
    nominatedIds.forEach((nominatedId, ix) => {
      const value = nominatedValues[ix];
      if (value.fromId === arrow.toId || value.toId === arrow.toId) {
        ids.push(nominatedId);
        values.push(value);
      }
    })
    if (ids.length === 0) return;
    ids.forEach((targetId, ix) => {
      const value = values[ix];
      if (value.order > arrow.order) dispatch(updateArrow({ id: targetId, order: value.order - 1 }));
    })
  }
  const deleteExe = (id: string | undefined) => {
    if (id) {
      dispatch(deleteArrow({id: id}));
      updateOrder();
    }
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>矢印を削除します</DialogTitle>
      <DialogContent />
      <DialogActions>
        <Button variant='text' color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button variant='text' color='primary' onClick={() => deleteExe(id)}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteArrowDialog;
